export default [
  {
    path: '/appraise/index',
    component: () =>
      import('../../pages/appraise/appraiseNew/appraiseIndex.vue'),
    meta: {
      title: '综合监管考核',
      keepAlive: true
    }
  },
  {
    path: '/appraise/detail',
    component: () =>
      import('../../pages/appraise/appraiseNew/appraiseDetail.vue'),
    meta: {
      title: '综合监管考核',
      keepAlive: true
    }
  },
  {
    path: '/appraise/rankList',
    component: () =>
      import('../../pages/appraise/appraiseNew/appraiseRanking.vue'),
    meta: {
      title: '综合监管考核'
    }
  },
  {
    path: '/appraise/deduction_list',
    component: () =>
      import('../../pages/appraise/appraiseNew/deductionList.vue'),
    meta: {
      title: '扣分列表'
    }
  },
  {
    path: '/appraise/deduction_detail',
    component: () =>
      import('../../pages/appraise/appraiseNew/deductionDetail.vue'),
    meta: {
      title: '扣分详情'
    }
  },
  {
    path: '/apprsise/transitionpage', //过渡页
    component: () =>
      import('../../pages/appraise/appraiseNew/transitionpage.vue'),
    meta: {
      title: '新增附件'
    }
  },
  {
    path: '/appraise/add_enclosure',
    component: () =>
      import('../../pages/appraise/appraiseNew/addEnclosure.vue'),
    meta: {
      title: '新增附件'
    }
  },
  {
    //已有附件时，编辑附件
    path: '/appraise/update_enclosure',
    component: () =>
      import('../../pages/appraise/appraiseNew/updateEnclosure.vue'),
    meta: {
      title: '编辑附件'
    }
  },
  {
    path: '/appraise/iframepdf',
    component: () =>
      import('../../pages/appraise/appraiseNew/windowIfrram.vue'),
    meta: {
      title: '预览附件'
    }
  },
  {
    path: '/appraise/autiting',
    component: () =>
      import('../../pages/appraise/appraiseNew/deduvtionAudition.vue'),
    meta: {
      title: '审核'
    }
  },
  //综合监管 A3 新增编辑
  {
    path: '/appraise/travel_cases',
    component: () => import('../../pages/appraise/appraiseNew/travelCases.vue'),
    meta: {
      title: '新增情况'
    }
  },
  {
    path: '/appraise/custable',
    component: () =>
      import('../../pages/appraise/appraiseNew/components/customTable.vue')
  },
  // 1+16+129+X模块
  {
    path: '/appraise/assessB',
    name: 'assessB',
    component: () =>
      import('../../pages/appraise/appraiseNew/bCategoryIndex.vue'),
    meta: {
      title: '扣分列表'
    }
  },
  {
    path: '/appraise/oprationSituation',
    name: 'oprationSituation',
    component: () =>
      import('../../pages/appraise/deductMarks/oprationSituation/index.vue'),
    meta: {
      title: '扣分列表'
    }
  },
  // 投诉5分钟内未响应
  {
    path: '/appraise/fiveMunites',
    name: 'fiveMunites',
    component: () =>
      import(
        '../../pages/appraise/deductMarks/oprationSituation/fiveMunites.vue'
      ),
    meta: {
      title: '扣分详情'
    }
  },
  // 投诉超24小时未办结
  {
    path: '/appraise/twentyFourHours',
    name: 'twentyFourHours',
    component: () =>
      import(
        '../../pages/appraise/deductMarks/oprationSituation/twentyFourHours.vue'
      ),
    meta: {
      title: '扣分详情'
    }
  },
  // 投诉办结率24小时未达95%
  {
    path: '/appraise/nintyFivePercent',
    name: 'nintyFivePercent',
    component: () =>
      import(
        '../../pages/appraise/deductMarks/oprationSituation/nintyFivePercent.vue'
      ),
    meta: {
      title: '扣分详情'
    }
  },
  {
    path: '/appraise/deducList_FivemitnusAll',
    name: 'deducList_FivemitnusAll',
    component: () =>
      import('../../pages/appraise/deductMarks/components/deducList-all.vue'),
    meta: {
      title: '投诉5分钟内未响应',
    }
  },
  {
    path: '/appraise/deducList_twfoNOAll',
    name: 'deducList_twfoNOAll',
    component: () =>
      import('../../pages/appraise/deductMarks/components/deducList-all.vue'),
    meta: {
      title: '投诉超24小时未办结'
    }
  },
  {
    path: '/appraise/deducList_twfoAll',
    name: 'deducList_twfoAll',
    component: () =>
      import('../../pages/appraise/deductMarks/components/deducList-all.vue'),
    meta: {
      title: '投诉办结率24小时未达95%'
    }
  },
  // 游客投诉率
  {
    path: '/appraise/touristComplain',
    name: 'touristComplain',
    component: () => import('../../pages/appraise/deductMarks/touristComplain'),
    meta: {
      title: '扣分详情'
    }
  },
  // 游客投诉处置效率
  {
    path: '/appraise/complainDispose',
    name: 'complainDispose',
    component: () => import('../../pages/appraise/deductMarks/complainDispose'),
    meta: {
      title: '扣分详情'
    }
  },
  // 投诉处置满意度
  {
    path: '/appraise/touristDispose',
    name: 'touristDispose',
    component: () =>
      import('../../pages/appraise/deductMarks/touristDispose/index.vue'),
    meta: {
      title: '扣分详情'
    }
  },
  // 游客体验满意度
  {
    path: '/appraise/touristExperience',
    name: 'touristExperience',
    component: () =>
      import('../../pages/appraise/deductMarks/touristExperience'),
    meta: {
      title: '扣分详情'
    }
  },
  // 投诉列表
  {
    path: '/appraise/complainLists',
    name: 'complainLists',
    component: () => import('../../pages/appraise/deductMarks/complainList'),
    meta: {
      title: '扣分详情'
    }
  },
  {
    path: '/appraise/scoreLists',
    name: 'scoreLists',
    component: () => import('../../pages/appraise/deductMarks/scoreList'),
    meta: {
      title: '扣分详情'
    }
  },
  // 游客投诉增长率
  {
    path: '/appraise/touristComplainIncresRate',
    name: 'touristComplainIncresRate',
    component: () =>
      import('../../pages/appraise/appraiseNew/touristComplainIncresRate.vue'),
    meta: {
      title: '扣分详情'
    }
  },

  // 游客投诉处置满意度
  {
    path: '/appraise/touristComplainHandleSatisfaction',
    name: 'touristComplainHandleSatisfaction',
    component: () =>
      import(
        '../../pages/appraise/appraiseNew/touristComplainHandleSatisfaction.vue'
      ),
    meta: {
      title: '扣分详情'
    }
  },
  // 30 天无理由退货
  {
    path: '/appraise/assessK',
    name: 'assessK',
    component: () =>
      import('../../pages/appraise/appraiseNew/kCategoryIndex.vue'),
    meta: {
      title: '扣分列表'
    }
  },
  {
    path: '/appraise/kCategoryDetail',
    name: 'assessKDetail',
    component: () =>
      import('../../pages/appraise/appraiseNew/kCategoryDetail.vue'),
    meta: {
      title: '扣分列表'
    }
  }
];
